import { useDispatch } from 'react-redux';
import { pickDefaultModelResult } from '../../../../../common/model/data-point-pickers';
import { packImpactScoresByIVV } from '../../../../../common/model/output/scores';
import { FinalImpactScoreType } from '../../../../../common/model/output/scores/types';
import { CONTRIBUTE_MODAL_NAME } from '../../../../common/upright/model/input/contributions/contribution-modal';
import { ModalOptions, openModal } from '../../../../untidy/redux/modules/modal';
import { friendlySource } from '../../../../untidy/texts';
import { useCompany } from '@upright/ui/api/model/input/companies';
import { useCompanyProductNames } from '@upright/ui/views/model-entity-views/company-view/use-product-names';
import { useCompanyScores } from '@upright/ui/views/model-entity-views/company-view/use-company-scores';

export function useOpenContributeModal(companyId: string) {
  const dispatch = useDispatch();

  const company = useCompany(companyId).data;
  const companyScoresQuery = useCompanyScores(companyId);
  const scoreData = companyScoresQuery.data;
  const productNames = useCompanyProductNames(companyId);

  if (!company || !scoreData || !productNames) {
    return () => undefined;
  }

  const ret = () => {
    const modelResult = pickDefaultModelResult(scoreData.modelResults);

    const impactScores = modelResult.impactScoresByTIVV;
    const revenue = company.revenues.map(datum => {
      return {
        source: friendlySource(datum),
        value: datum.value.toString(),
      };
    });
    const employees = company.employeeCounts.map(datum => {
      return {
        source: friendlySource(datum),
        value: datum.count.toString(),
      };
    });

    const products = productNames.map(p => ({
      productCode: p.id,
      label: p.name,
    }));

    const options: ModalOptions = {
      type: 'company',
      target: company.id,
      targetName: company.name,
      existingData: {
        revenue,
        employees,
        products,
        impacts: packImpactScoresByIVV(impactScores[FinalImpactScoreType.RELATIVE]),
      },
    };
    dispatch(openModal(CONTRIBUTE_MODAL_NAME, options));
  };
  return ret;
}
